var map = {
	"./cover-molegame.webp": 20973,
	"./cover-pick.webp": 32837,
	"./cover-punchboard.webp": 6560,
	"./cover-pvpgame.webp": 37412,
	"./cover-tfgame.webp": 81308
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41821;